module.exports = __webpack_public_path__ + "static/10-stress-detection-report-714c988b8e8a82a81c002d19d842cfa0.png";